import { GoogleMap, Marker } from 'vue3-google-map';
import { Loader as GmapLoader } from '@googlemaps/js-api-loader';
import _debounce from 'lodash/debounce';
import proj4 from 'proj4';
import Loader from '../../Loader/Loader.vue';

export default {
  props: {
    context: {
      type: Object,
    },
  },

  components: {
    GoogleMap,
    Marker,
    Loader,
  },

  mounted() {
    const loader = new GmapLoader({
      apiKey: 'AIzaSyA7Vquofh7lxKL_m0LNENOzvtzz1zw9Jj8',
      version: 'weekly',
    });

    this.apiPromise = loader.importLibrary('maps');

    loader.importLibrary('geocoding').then(({ Geocoder }) => {
      this.geocoder = new Geocoder();
      this.geocodeAddress();
    });

    this.$formkit.get('kiw_form--address_street').on('input', () => {
      this.geocodeAddress();
    });
    this.$formkit.get('kiw_form--address_number').on('input', () => {
      this.geocodeAddress();
    });
    this.$formkit.get('kiw_form--postcode').on('input', () => {
      this.geocodeAddress();
    });
    this.$formkit.get('kiw_form--address_city').on('input', () => {
      this.geocodeAddress();
    });
  },

  data() {
    return {
      center: null,
      apiPromise: null,
      geocoder: null,
      mapOptions: {
        controls: false,
      },
    };
  },

  computed: {},

  methods: {
    geocodeAddress: _debounce(function () {
      this.geocoder.geocode({ address: `${this.$formkit.get('kiw_form--address_street').value} ${this.$formkit.get('kiw_form--address_number').value}, ${this.$formkit.get('kiw_form--postcode').value} ${this.$formkit.get('kiw_form--address_city').value}` }).then(({ results }) => {
        if (results.length) {
          this.center = results[0].geometry.location;
          this.context.node.input(convertLatLngToLambert(results[0].geometry.location.lat(), results[0].geometry.location.lng()));
        }
      });
    }, 500),
    onMarkerDrop(e) {
      this.context.node.input(convertLatLngToLambert(e.latLng.lat(), e.latLng.lng()));
    },
  },

  watch: {},
};

function convertLatLngToLambert(lat, lon) {
  // testing new service
  // Define the source CRS (WGS84 - EPSG:4326)
  const wgs84 = 'EPSG:4326';
  // Register CRS definitions (optional if EPSG:31370 is predefined)
  proj4.defs('EPSG:31370', '+proj=lcc +lat_0=90 +lon_0=4.36748666666667 +lat_1=51.1666672333333 +lat_2=49.8333339 +x_0=150000.013 +y_0=5400088.438 +ellps=intl +towgs84=-106.8686,52.2978,-103.7239,0.3366,-0.457,1.8422,-1.2747 +units=m +no_defs +type=crs');
  // Transform coordinates from WGS84 to Lambert-93
  const lonLat = [lon, lat];
  const lambertCoords = proj4(wgs84, 'EPSG:31370', lonLat);

  console.log(`x=${lambertCoords[0]}&y=${lambertCoords[1]}`);

  return `x=${lambertCoords[0]}&y=${lambertCoords[1]}`;
}
